module.exports = __webpack_public_path__ + "static/media/about-1.a28869b1.jpeg";